import { Link } from "react-router-dom";
import BgShape from "../images/hero/hero-bg.png";
import HeroCar from "../assets/images/cars (3).png";

import ab from '../assets/images/about1.png';

import { useEffect, useState } from "react";
// import { IconChevronRight, IconCircleCheck } from "@tabler/icons-react";


import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

function Hero() {
  const [goUp, setGoUp] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({ top: (0, 0), behavior: "smooth" });
  };

  const bookBtn = () => {
    document
      .querySelector("#booking-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };
    window.addEventListener("scroll", onPageScroll);

    return () => {
      window.removeEventListener("scroll", onPageScroll);
    };
  }, []);
  return (
    <>
      <section id="home" className="hero-section">
        <div className="container">
          <img className="bg-shape" src={BgShape} alt="bg-shape" />
          <div className="hero-content">
            <div className="hero-content__text">
              <h4>Plan your trip now</h4>
              <h1>
                Save <span>big</span> with Our car rental
              </h1>
              <p className="efeefefree">
                Rent the car of your dreams. Unbeatable prices, Professional Drivers,
                flexible pick-up options and much more.
              </p>
              <div className="hero-content__text__btns">
                {/* <Link
                  onClick={bookBtn}
                  className="hero-content__text__btns__book-ride kjkjkj"
                  to="/"
                >
                  Book Ride &nbsp; <CheckCircleOutlineIcon />
                </Link> */}
                <a className="hero-content__text__btns__learn-more kjkjkj" href="tel:+92 345 554 3142">
                  Call Now &nbsp; <ChevronRightIcon />
                </a>
              </div>
            </div>

            {/* img */}
            <img
              src={HeroCar}
              alt="car-img"
              className="hero-content__car-img"
            />
          </div>
        </div>

        {/* page up */}
        <div
          onClick={scrollToTop}
          className={`scroll-up ${goUp ? "show-scroll" : ""}`}
        >
          ^
        </div>
      </section>
    </>
  );
}

export default Hero;
